export enum DocumentUploadAccountTypes {
  INDIVIDUAL_JOINT_BROKERAGE = 'Individual/joint brokerage',
  IRA = 'IRA',
  ESTATE = 'Estate',
  TRUST_UNDER_AGREEMENT = 'Trust under agreement',
  TRUST_UNDER_WILL = 'Trust under will',
}
